module.exports = __webpack_public_path__ + "static/media/concrete-building.614b6fdb.jpg";